import { GET_LIST } from '../../dataFetchActions';
import { CRUD_GET_LIST } from './crudconstants';

/** @deprecated We are phasing out legacy redux, use immi query instead */
export const crudGetList = (resource, location, config = {}) => ({
  type: CRUD_GET_LIST,
  payload: {
    pagination: config.pagination || {
      page: 1,
      perPage: 10
    },
    sort: config.sort || {},
    filter: config.filter || {},
    fields: config.fields
  },
  meta: {
    context: config.context,
    resource,
    subResource: config.subResource,
    location,
    id: config.componentId || 'default',
    type: GET_LIST,
    fetch: GET_LIST,
    onFailure: {
      notification: {
        body: config.failureMessage || 'notification.http_error',
        level: config.failureLevel || 'warning',
      },
    },
  },
});
